import {OrganizationBaseInformationTypes} from 'appRedux/actions/auth/types';

import {HASH_SSO} from 'config/index';

export const shouldCreateNewCaseViaSso = (organization: OrganizationBaseInformationTypes, hash: string) => {
    const {isAutoSsoEnabled, isSsoActive, isClosed} = organization;
    return isSsoActive && ((isAutoSsoEnabled && isClosed) || hash === HASH_SSO);
};
